import * as tslib_1 from "tslib";
import { ChangeDetectorRef, EventEmitter, ViewContainerRef } from '@angular/core';
import { LayerService } from '../../../services/layer.service';
import { MapService } from '../../../services/map.service';
import { BaseComponent } from '../../base.component';
var MergeMapComponent = /** @class */ (function (_super) {
    tslib_1.__extends(MergeMapComponent, _super);
    function MergeMapComponent(_vcr, layerService, mapService, cdr) {
        var _this = _super.call(this, _vcr, true) || this;
        _this.layerService = layerService;
        _this.mapService = mapService;
        _this.cdr = cdr;
        _this.includeMapFilter = false;
        _this.ondone = new EventEmitter();
        _this.oncancel = new EventEmitter();
        _this.mapLayers = [];
        _this.isAllLayersSelected = false;
        _this.loading = false;
        _this.registerEvent('ondone', _this.ondone);
        _this.registerEvent('oncancel', _this.oncancel);
        return _this;
    }
    Object.defineProperty(MergeMapComponent.prototype, "map", {
        get: function () {
            return this._map;
        },
        set: function (value) {
            if (value) {
                this._map = value;
                this.getMapLayers();
            }
        },
        enumerable: true,
        configurable: true
    });
    MergeMapComponent.prototype.getMapLayers = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1, _a, mapData, yearConfig, layers, layers_1, layers_1_1, layer, mapLayer;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.loading = true;
                        mapData = JSON.parse(this.map.data);
                        this.cdr.detectChanges();
                        yearConfig = [];
                        if (mapData && mapData.paramConfig) {
                            yearConfig = mapData.paramConfig.filter(function (x) { return x.type === 'CYFY'; });
                        }
                        return [4 /*yield*/, this.layerService.getLayers(this.getLayerIds(mapData.layers))];
                    case 1:
                        layers = _b.sent();
                        try {
                            for (layers_1 = tslib_1.__values(layers), layers_1_1 = layers_1.next(); !layers_1_1.done; layers_1_1 = layers_1.next()) {
                                layer = layers_1_1.value;
                                if (yearConfig && yearConfig.length > 0) {
                                    this.layerService.updateLayerName(yearConfig[0], layer.mapcoreProps);
                                }
                                mapLayer = {
                                    name: layer.mapcoreProps.name,
                                    id: layer.mapcoreProps.id,
                                    description: layer.mapcoreProps.description,
                                    isChecked: false
                                };
                                this.mapLayers.push(mapLayer);
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (layers_1_1 && !layers_1_1.done && (_a = layers_1.return)) _a.call(layers_1);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        this.loading = false;
                        this.cdr.detectChanges();
                        return [2 /*return*/];
                }
            });
        });
    };
    MergeMapComponent.prototype.getLayerIds = function (layers) {
        var _this = this;
        return layers.flatMap(function (layer) {
            if (layer.id) {
                return layer.id;
            }
            else {
                return _this.getLayerIds(layer.layers);
            }
        });
    };
    MergeMapComponent.prototype.toggleLayers = function () {
        var _this = this;
        this.mapLayers.forEach(function (lyr) { return lyr.isChecked = !_this.isAllLayersSelected; });
    };
    MergeMapComponent.prototype.checkAllSelected = function (lyr) {
        if (!lyr.isChecked) {
            this.isAllLayersSelected = false;
        }
        else {
            var checkedLayers = this.mapLayers.filter(function (l) { return l.isChecked; });
            this.isAllLayersSelected = checkedLayers.length === this.mapLayers.length;
        }
    };
    MergeMapComponent.prototype.addToMap = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var layers;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.mapService.mapStatus.next('loading');
                        layers = this.mapLayers.filter(function (lyr) { return lyr.isChecked; });
                        return [4 /*yield*/, this.layerService.addMapcoreLayersToMap(layers)];
                    case 1:
                        _a.sent();
                        this.mapService.mapStatus.next('loaded');
                        this.clearData();
                        this.ondone.emit(this.includeMapFilter);
                        return [2 /*return*/];
                }
            });
        });
    };
    MergeMapComponent.prototype.cancel = function () {
        this.clearData();
        this.oncancel.emit();
    };
    MergeMapComponent.prototype.clearData = function () {
        this.map = null;
        this.mapLayers = [];
        this.isAllLayersSelected = false;
    };
    return MergeMapComponent;
}(BaseComponent));
export { MergeMapComponent };
